import LogoHEATSquare from "@ui-components/layout/LogoHEATSquare";

const Logo = ({height = '80', width = '80'}) => (
    <div className="flex shrink-0 items-center justify-center">
        <LogoHEATSquare width={width} height={height} color="black" />
    </div>
);

export default Logo;
